import React from "react";
import { LazyLoadImage } from "react-lazy-load-image-component";
import "react-lazy-load-image-component/src/effects/blur.css";
import "./SpendTime.css";

const SpendTime = () => {
  return (
    <>
      <div className="container spend-time-section">
        <div className="row px-lg-5">
          <div className="col-md-6">
            <h1 className="headings ps-2 ps-md-0">
              <span>Indulge in Luxe </span>BLeisure Travel with Blueberry!
            </h1>
            <p className="spendtime-1 mt-xxl-4 mt-md-3 ps-2 ps-md-0 grotesk-headings">
              We understand work should never feel like sacrificing your peace.
              So, here we are crafting Bleisure travel packages that are the
              perfect amalgam of productivity with relaxation. Enjoy stress-free
              travel with personalized itineraries, exclusive leisure
              experiences, and a touch of luxury wherever you go.
            </p>
            <p className="spendtime-2 grotesk-headings">
              From premium staycations and customized activities to simplified
              business travel solutions, we are here to handle everything so you
              can focus on what matters the most. With Blueberry Travel, every
              business trip becomes an opportunity to relax and explore new
              horizons. Let us redefine your corporate travel experience mixed
              with a perfect getaway to your preferred destination, making each
              journey not just productive but also a lifetime of memories.{" "}
            </p>
          </div>

          <div className="col-md-6">
            <div className="spend-img d-flex justify-content-center">
              <LazyLoadImage
                src="https://blueberrywebsites.azureedge.net/bbt/images/spentime-img.png"
                alt=""
                loading="lazy"
              />
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default SpendTime;
